import { AlertTriangle, Inbox, Loader2 } from 'lucide-react';
import type { ReactNode } from 'react';

import { mensajeDe } from '@/api/errors';

/** Estados de carga, vacío y error de cualquier pantalla del panel. */
export function Cargando({ texto = 'Cargando…' }: { texto?: string }) {
  return (
    <p role="status" className="flex items-center gap-2 py-10 text-texto-2">
      <Loader2 size={18} className="animate-spin" aria-hidden /> {texto}
    </p>
  );
}

export function Vacio({ titulo, children }: { titulo: string; children?: ReactNode }) {
  return (
    <div className="flex flex-col items-center gap-2 py-12 text-center text-texto-2">
      <Inbox size={32} aria-hidden className="text-texto-3" />
      <p className="font-bold text-texto">{titulo}</p>
      {children}
    </div>
  );
}

export function ErrorCarga({ error, onReintentar }: { error: unknown; onReintentar?: () => void }) {
  return (
    <div role="alert" className="panel-vidrio flex flex-col items-start gap-3">
      <p className="flex items-center gap-2 font-bold text-rojo-texto">
        <AlertTriangle size={18} aria-hidden /> {mensajeDe(error)}
      </p>
      {onReintentar && (
        <button type="button" className="btn-cs btn-contorno" onClick={onReintentar}>
          Reintentar
        </button>
      )}
    </div>
  );
}

export function Encabezado({
  titulo,
  descripcion,
  acciones,
}: {
  titulo: string;
  descripcion?: string;
  acciones?: ReactNode;
}) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h1 className="text-2xl font-extrabold text-azul-texto">{titulo}</h1>
        {descripcion && <p className="mt-1 text-texto-2">{descripcion}</p>}
      </div>
      {acciones && <div className="flex gap-2">{acciones}</div>}
    </div>
  );
}
